import React, { useState } from 'react'
import VoucherManagement from './sections/voucherManagement/VoucherManagement';
import { BrowserRouter as Router, Route, Switch, useHistory } from 'react-router-dom';
import GuardedRoute from 'common/components/GuardedRoute';
import Login from './sections/login/Login';
import ErrorBoundary from 'common/components/ErrorBoundary';
import FlashMessageListing from 'common/components/flashMessage/FlashMessageListing';
import Home from 'sections/home/Home';
import { useAuthentication } from 'common/contexts/Authentication';
import AuthenticatedUserNav from 'common/components/AuthenticatedUserNav';
import Header from 'components/Header';
import UserManagement from 'sections/userManagement/UserManagement';
import Reports from 'sections/reports/Reports';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import LeftMenu from 'common/components/LeftMenu';
import General from 'sections/analyticsPortal/src/components/Stories/General';
import { useReports } from 'common/contexts/Reports';

const App = () => {
  console.log('Loading Etuisa application')
  const authentication = useAuthentication();
  const history = useHistory();
  const { t } = useTranslation();
  const { currentDashboard, dashboards } = useReports();


  const [ mobileMenuOpen, setMobileMenuOpen ] = useState(false);

  const handleSignOut = () => {
    authentication.reset();
    history.push({ pathname: '/login' });
  };

  useEffect(() => {
    if(!authentication.isAuthenticated()){
      handleSignOut();
    }
  }, [ authentication ]);

  useEffect(() => {
    if(history.location.pathname === '/general' && currentDashboard.name){
      history.push({ pathname: `/general/${currentDashboard.name}`});
    }
  }, [ history.location.pathname ]);

  useEffect(() => {
    document.title = t('common:title');
    if((currentDashboard.name && history.location.pathname === '/')){
      history.push({ pathname: `/general/${currentDashboard.name}`});
    }
  }, [ dashboards ]);

  return (
    <ErrorBoundary>
        <LeftMenu mobileMenuOpen={ mobileMenuOpen } setMobileMenuOpen={ setMobileMenuOpen } />
        <div className={ `body-wrap ${authentication.isAuthenticated() ? '' : 'not-sign-in'}` }>
          <Header toggleMenu={ setMobileMenuOpen }>
            <AuthenticatedUserNav onSignOut={handleSignOut} />
          </Header>
          <FlashMessageListing />
          <div id="content">
            <Switch>
              <Route path='/login' exact component={Login} />
              <GuardedRoute path='/reports' component={Reports} />
              <GuardedRoute exact path='/' component={General} />
              <GuardedRoute path='/general/:name' component={General} />
              <GuardedRoute path='/voucherManagement' component={VoucherManagement} />
              <GuardedRoute path='/userManagement' component={UserManagement} />
            </Switch>
          </div>
        </div>
    </ErrorBoundary>
  );
};

export default App;
